"use client";

import { hasBrowserAnalyticsConsent } from "~/lib/consent-region";
import {
  capturePostHogEvent,
  isPostHogBrowserEnabled,
  posthog,
} from "~/lib/posthog/client";
import { shouldCapturePostHogClientSignal } from "~/lib/posthog/client-rate-limit";

function getBrowserTechnicalProperties(
  properties?: Record<string, unknown>,
): Record<string, unknown> {
  return {
    runtime: "browser",
    page_path:
      typeof window === "undefined" ? undefined : window.location.pathname,
    page_location:
      typeof window === "undefined" ? undefined : window.location.href,
    ...properties,
  };
}

function getErrorRateLimitKey(
  error: unknown,
  properties?: Record<string, unknown>,
): string {
  const source =
    typeof properties?.source === "string" ? properties.source : "unknown";

  if (error instanceof Error) {
    return `exception:${source}:${error.name}:${error.message}`;
  }

  return `exception:${source}:${typeof error}`;
}

export function capturePostHogClientException(
  error: unknown,
  properties?: Record<string, unknown>,
): void {
  if (!hasBrowserAnalyticsConsent()) {
    return;
  }

  if (!isPostHogBrowserEnabled()) {
    return;
  }

  if (
    !shouldCapturePostHogClientSignal(getErrorRateLimitKey(error, properties))
  ) {
    return;
  }

  posthog.captureException(error, getBrowserTechnicalProperties(properties));
}

export function addPostHogClientBreadcrumb(
  properties: Record<string, unknown>,
): void {
  if (!hasBrowserAnalyticsConsent()) {
    return;
  }

  capturePostHogEvent(
    "client_breadcrumb",
    getBrowserTechnicalProperties(properties),
  );
}
